import { Component, inject } from '@angular/core';
import { NotificationService } from 'src/app/core/services/Notification/notification.service';

@Component({
  selector: 'app-notification',
  templateUrl: './notification.component.html',
})
export class NotificationComponent {
  notify: NotificationService = inject(NotificationService);
}